import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface InfoState {
  info: any;
  setInfo: (info: any) => void;
}

export const useAccountStore = create<InfoState>()(
  persist(
    (set) => ({
      info: undefined,
      setInfo: (info) => set(() => ({ info })),
    }),
    {
      name: "account-store-persist",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
